import { pushToDataLayer } from "../../07-libs/GtmGlobalTrackingValue";
import luxLeadUpdate from "../../07-libs/luxLeadUpdate";

function initializeFaqGtmTracking() {
  const faqItems = document.querySelectorAll(".tx-goldgas-faq");
  if (!faqItems.length) return;

  function init() {
    faqItems.forEach(faqItem => {
      const luxLead = new luxLeadUpdate("faq-opening", 30);
      listenForClicks(faqItem, luxLead);
    });
  }

  function listenForClicks(faqItem, luxLead) {
    faqItem.addEventListener("click", event => {
      let target = event.target;
      while (target !== faqItem) {
        if (target.matches(".accordion__icon-wrapper")) {
          handleCopyClick(target);
          return;
        }
        if (target.matches(".accordion")) {
          handleAccordionClick(target, luxLead);
          return;
        }
        target = target.parentElement;
      }
    });
  }

  function handleAccordionClick(accordion, luxLead) {
    if (!checkIfClickedOnInactiveAccordion(accordion)) {
      return;
    }
    luxLead.increaseValue();
    const payload = {
      label: getAccordionLabel(accordion),
    };
    pushToDataLayer("faq", payload);
  }

  function handleCopyClick(accordion) {
    const item = accordion.closest(".accordion__item");
    const payload = {
      label: getAccordionLabel(item),
      targetUrl: getFaqDetailUrl(item),
    };
    pushToDataLayer("faqCopyClick", payload);
  }

  function checkIfClickedOnInactiveAccordion(accordion) {
    const item = accordion.querySelector(".accordion__item--active");
    return item ? true : false;
  }

  function getAccordionLabel(accordion) {
    const label = accordion.querySelector(".accordion__label");
    return label.innerText;
  }

  function getFaqDetailUrl(accordion) {
    const detailLinkEl = accordion.querySelector(".accordion__icon-wrapper");
    return detailLinkEl.dataset.value;
  }

  init();
}

export default initializeFaqGtmTracking;
